/**
 * [订单管理-配送订单]
 * @author: Fu Xiaochun
 * @date: 2021-09-03 
 */

import http from '@/assets/api/http';

// 三方渠道枚举列表
export async function getThirdPartyChannelsEnum(params){
    return http('/?cmd=com.xqxc.api.pig.mis.biz.platform.PfOpenapiAppkeyInfoService.getPair',params,'POST');
}

// 配送订单数据统计
export async function getStatisticsData(params){
    return http('/?cmd=com.xqxc.api.pig.mis.order.DeliveryOrderManageMisService.getDeliveryData',params,'POST');
}